import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import React from 'react';
import BrokenAuthorizationFormHandler from '../containers/forms/fraud/BrokenAuthorizationFormHandler';
import BrokenTransactionsFormHandler from '../containers/forms/fraud/BrokenTransactionsFormHandler';

const tabHeaders = ['Autorisations Transgressées', 'Transactions Trangressées', 'Rapport Des Porteurs à Risque']

const Fraud = () => {

    const tabContents = React.useMemo(() => [<BrokenAuthorizationFormHandler />, <BrokenTransactionsFormHandler />], []);
  return (
    <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} />
  )
}

export default Fraud